import { render, staticRenderFns } from "./StuffList.vue?vue&type=template&id=39a68ccf&"
import script from "./StuffList.vue?vue&type=script&lang=js&"
export * from "./StuffList.vue?vue&type=script&lang=js&"
import style0 from "./StuffList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports